// extracted by mini-css-extract-plugin
export default {"container":"SelectedOffers_container__cwlGR","item":"SelectedOffers_item__HVvFk","selected":"SelectedOffers_selected__vrkRJ","img":"SelectedOffers_img__Kl62c"};